import { ApplicationRef } from '@angular/core';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { AttributionFactorAnalysisModule } from 'SecuritiesApp/ts/features/attribution-factor-analysis/attribution-factor-analysis.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { AttributionFactorAnalysisComponent } from 'SecuritiesApp/ts/features/attribution-factor-analysis/components/attribution-factor-analysis.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
export class MutualFundsAttributionFactorAnalysisAppModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(AttributionFactorAnalysisComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
    }
}
MutualFundsAttributionFactorAnalysisAppModule.ɵfac = function MutualFundsAttributionFactorAnalysisAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsAttributionFactorAnalysisAppModule)(); };
MutualFundsAttributionFactorAnalysisAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsAttributionFactorAnalysisAppModule });
MutualFundsAttributionFactorAnalysisAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, AttributionFactorAnalysisModule] });
